import { tv } from '@/common/theme/tv.config';

export const styles = {
  root: 'w-full h-full sm:flex-row-reverse gap-lg sm:gap-0',
  column: tv({
    base: 'h-auto w-full shrink px-lg sm:h-full sm:w-[50%] sm:p-2xl sm:px-2xl',
    variants: {
      content: {
        true: 'grow justify-start px-0 sm:grow-0 sm:justify-center sm:px-0 sm:pb-0',
      },
    },
  }),
  scrollView: 'grow sm:grow-0',
  scrollViewContent: 'px-lg sm:px-2xl',
  scrollColumn: 'gap-lg flex-1',
  asset: tv({
    base: 'shrink-0',
    variants: {
      size: {
        md: 'h-[34.4rem]',
        lg: 'h-[70%] sm:h-[34.4rem]',
      },
    },
  }),
};
